module.exports = __webpack_public_path__ + "img/制御工学5_6_4.80a280bc.png";